<template src="./Group.html"></template>

<script>
import sitesTopMenu from "@/components/sites/components/topMenu"
import {createNamespacedHelpers} from 'vuex';

const {mapGetters, mapActions} = createNamespacedHelpers('sites/group');

export default {
  name: "SiteGroup",
  components: {
    sitesTopMenu
  },
  data() {
    return {
      showBottomOverlay: false,
      showOverlay: false,
      groupFilter: false,
      mainMenuSize: null,
      fieldsList: [
        {
          key: 'groupName',
          label: 'Группа',
          sortable: false
        },
        {
          key: 'sites',
          label: 'Сайты',
          sortable: false
        },
      ],
      lastScrollCheck: false,
      bottomOverlayLength: 0
    }
  },
  methods: {
    ...mapActions(['GET_GROUPS', 'GET_DATA', 'PER_PAGE']),
    partLoadData: function () {
      if (
          !this.isBottomScroll()
          || this.groupFilter == null
          || this.showBottomOverlay > 0
          || this.lastScrollCheck
          || this.HAVE_EMPTY_RESPONSE
      ) {
        this.lastScrollCheck = false
        return
      }
      this.lastScrollCheck = true
      this.GET_DATA({th: this})
    },
    isBottomScroll: function () {
      let rect = this.$refs.bottomOverlay.getBoundingClientRect()
      let queryRect = this.$refs.queryList.$el.getBoundingClientRect()

      if (
          (rect.bottom - queryRect.bottom) < 50
          && (window.innerHeight - rect.bottom) >= 0
          && (this.bottomOverlayLength - rect.bottom) > 0
      ) {
        this.bottomOverlayLength = rect.bottom
        return true
      }
      this.bottomOverlayLength = rect.bottom

      return false
    },
  },
  computed: {
    ...mapGetters(['GROUPS', 'SITES_DATA', 'PARAMS', 'CURRENT_PAGE', 'HAVE_EMPTY_RESPONSE', 'PER_PAGE']),
    firstSiteId: function () {
      return this.SITES_DATA[0]?.groupId?.toString() ?? '';
    },
    getGroupFilterOptions: function () {
      let groupOptions = []
      for (let key in this.GROUPS) {
        let val = this.GROUPS[key]
        groupOptions.push({value: val, text: val})
      }
      groupOptions.push({value: 'null', text: ' Без группы'})

      return groupOptions
    }
  },
  watch: {
  },
  mounted: function () {
  },
  created() {
    if (this.SITES_DATA.length == 0) {
      this.GET_DATA({th: this})
    }
    window.addEventListener("scroll", this.partLoadData)
  },
  destroyed() {
    window.removeEventListener('scroll', this.partLoadData)
  },
}
</script>

<style scoped>
.tab-width {
  width: 4000px;
}

.tab-scroll {
  overflow-x: scroll;
  width: 1920px;
}

.t-cell {
  overflow: hidden;
  display: block;
  height: 23px;
  font-size: 0.9rem;
  padding: 0 0.2rem;
}

.resizable-component {
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: #e9ecef;
  padding: 0.5rem;
  text-align: left;
  font-size: 0.9rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin: 0;
}

.cell-detail.resizable-content {
  background-color: #e9ecef;
}

.cell-cursor {
  cursor: cell;
  padding: 1px;
}

.cell-cursor:hover {
  border: solid 1px grey;
  padding: 0;
}

.cell-cursor.selectedCall {
  border: solid 2px #007bff;
  padding: 0;
}

.name-coll-selected {
  font-size: 0.8rem;
  display: block;
}

.common-head-cell {
  height: 4rem;
  display: block;
  text-align: center;
  padding: 0 0.2rem;
}

.index-call {
  vertical-align: middle;
}

.t-head-cell.number-head {
  display: block;
}

.text-align-left {
  text-align: left;
}

.text-align-right {
  text-align: right;
}

.resizable-content {
  height: 100%;
  width: 100%;
  background-color: aqua;
}

.b-table-sticky-header, .table-responsive, [class*="table-responsive-"] {
  margin-bottom: 0;
}

.apply-cancel-import {
  width: 150px;
}

.pagination-box {
  overflow: auto;
}

.table {
  margin-bottom: 0;
}

.sign-val {
  width: 130px;
}

.input-filter {
  min-width: 150px;
}
.site-group-list {
  min-height: 1057px;
  position: relative;
}
.bottom-overlay {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
}
</style>

<style>
.table th, .table td {
  padding: 0;
  vertical-align: middle;
}

.goods-import html {
  overflow-x: hidden;
}
</style>